import React from 'react';
import { ReactElement, useState } from 'react';

import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Close } from '@bphxd/ds-core-react';
import NoticeBarProvider from '../NoticeBar/NoticeBar';

export type TFormModal = React.FC<{
  title: string;
  renderForm: (onClose: () => void) => ReactElement;
  renderButton: (onClick: () => void) => ReactElement;
  size?: string
}>;

export const FormModal: React.FC<{
  title: string;
  renderForm: (onClose: () => void) => ReactElement;
  renderButton: (onClick: () => void) => ReactElement;
  size?: string
}> = ({ title, renderForm, renderButton, size }) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal((v) => !v);

  return (
    <>
      {renderButton && renderButton(() => setModal(true))}
      <Modal size={size ? size : 'md'} isOpen={modal} toggle={toggle} className="modal-dialog-centered">
        <ModalHeader className="border-0 px-7" close={<Close onClick={toggle} />}>
          {title}
        </ModalHeader>
        <NoticeBarProvider>
          <ModalBody className="p-5 pt-0">{renderForm(toggle)}</ModalBody>
        </NoticeBarProvider>
      </Modal>
    </>
  );
};

export default FormModal;
